import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconKeyboardDoubleArrowDownLine = ({
  width,
  height,
  fill = 'currentColor',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m12 16.512 4.073-4.058a.745.745 0 0 1 .514-.22.698.698 0 0 1 .54.22c.145.145.217.32.217.527a.718.718 0 0 1-.217.527l-4.494 4.494a.831.831 0 0 1-.633.256.832.832 0 0 1-.633-.256l-4.494-4.494a.745.745 0 0 1-.22-.515.698.698 0 0 1 .22-.54.718.718 0 0 1 .527-.216c.206 0 .382.072.527.217L12 16.512Zm0-5.981 4.073-4.058a.745.745 0 0 1 .514-.22.698.698 0 0 1 .54.22c.145.145.217.32.217.527a.718.718 0 0 1-.217.527l-4.494 4.494a.831.831 0 0 1-.633.256.832.832 0 0 1-.633-.256L6.873 7.527a.745.745 0 0 1-.22-.515.698.698 0 0 1 .22-.539.718.718 0 0 1 .527-.217c.206 0 .382.072.527.217L12 10.531Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconKeyboardDoubleArrowDownLine;
